var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { attrs: { role: "navigation", "aria-label": "dropdown navigation" } },
    [
      _vm.isSuperAdmin
        ? _c(
            "RouterLink",
            {
              staticClass: "navbar-item is-flex",
              attrs: { to: { name: "SuperAdmin" } }
            },
            [
              _c("BIcon", { attrs: { icon: "account-supervisor" } }),
              _c("span", [_vm._v("Admin")])
            ],
            1
          )
        : _vm._e(),
      _c(
        "RouterLink",
        {
          staticClass: "navbar-item is-flex link-sidebar-dashboard",
          attrs: { to: { name: "Dashboard" } }
        },
        [
          _c("BIcon", { attrs: { icon: "view-dashboard" } }),
          _c("span", [_vm._v("Dashboard")])
        ],
        1
      ),
      _c(
        "RouterLink",
        {
          staticClass: "navbar-item is-flex link-sidebar-calendar",
          attrs: { to: { name: "DebtsCalendar" } }
        },
        [
          _c("BIcon", { attrs: { icon: "calendar" } }),
          _c("span", [_vm._v("Calendario")])
        ],
        1
      ),
      _c(
        "RouterLink",
        {
          staticClass: "navbar-item is-flex link-sidebar-history",
          attrs: { to: { name: "StampedList", query: { size: 20, page: 1 } } }
        },
        [
          _c("BIcon", { attrs: { icon: "format-list-bulleted" } }),
          _c("span", [_vm._v("Historial")])
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "navbar-item has-dropdown",
          class: { "is-active": _vm.activeMenus.includes("invoices") }
        },
        [
          _c(
            "a",
            {
              staticClass: "navbar-link is-flex link-sidebar-cfdis",
              on: {
                click: function($event) {
                  return _vm.activeMenu("invoices")
                }
              }
            },
            [
              _c("BIcon", { attrs: { icon: "bank" } }),
              _c("span", {}, [_vm._v("\n        CFDIS\n      ")])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "navbar-dropdown" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "navbar-item is-flex link-sidebar-new-invoice",
                  attrs: { to: { name: "NewInvoice" } }
                },
                [
                  _c("BIcon", { attrs: { icon: "plus" } }),
                  _c("span", [_vm._v("Factura")])
                ],
                1
              ),
              _c(
                "RouterLink",
                {
                  staticClass: "navbar-item is-flex link-sidebar-auto-invoice",
                  attrs: { to: { name: "NewAutoInvoice" } }
                },
                [
                  _c("BIcon", { attrs: { icon: "auto-fix" } }),
                  _c("span", [_vm._v("Autofactura")])
                ],
                1
              ),
              _c(
                "RouterLink",
                {
                  staticClass:
                    "navbar-item is-flex link-sidebar-new-credit-note",
                  attrs: { to: { name: "NewCreditNote" } }
                },
                [
                  _c("BIcon", { attrs: { icon: "credit-card-plus" } }),
                  _c("span", [_vm._v("Nota de Crédito")])
                ],
                1
              ),
              _c(
                "RouterLink",
                {
                  staticClass: "navbar-item is-flex link-sidebar-new-rep",
                  attrs: { to: { name: "NewRep" } }
                },
                [
                  _c("BIcon", { attrs: { icon: "file-document-box-outline" } }),
                  _c("span", [_vm._v("Complemento de Pago")])
                ],
                1
              ),
              _c(
                "RouterLink",
                {
                  staticClass: "navbar-item is-flex link-sidebar-new-transfer",
                  attrs: { to: { name: "TradeTransfer" } }
                },
                [
                  _c("BIcon", { attrs: { icon: "truck-delivery" } }),
                  _c("span", [_vm._v("Traslado")])
                ],
                1
              ),
              _c(
                "RouterLink",
                {
                  staticClass: "navbar-item is-flex link-sidebar-new-payroll",
                  attrs: { to: { name: "NewPayroll" } }
                },
                [
                  _c("BIcon", { attrs: { icon: "cash-multiple" } }),
                  _c("span", [_vm._v("Nómina")])
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "navbar-item has-dropdown",
          class: { "is-active": _vm.activeMenus.includes("receipts") }
        },
        [
          _c(
            "a",
            {
              staticClass: "navbar-link is-flex link-sidebar-receipts",
              on: {
                click: function($event) {
                  return _vm.activeMenu("receipts")
                }
              }
            },
            [
              _c("BIcon", { attrs: { icon: "receipt" } }),
              _c("span", {}, [_vm._v("\n        Notas\n      ")])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "navbar-dropdown" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "navbar-item is-flex link-sidebar-new-sale-note",
                  attrs: { to: { name: "NewSaleNote" } }
                },
                [
                  _c("BIcon", { attrs: { icon: "file-document-box-outline" } }),
                  _c("span", [_vm._v("Nota de Remisión")])
                ],
                1
              ),
              _c(
                "RouterLink",
                {
                  staticClass:
                    "navbar-item is-flex link-sidebar-new-salary-receipt",
                  attrs: { to: { name: "NewSalaryReceipt" } }
                },
                [
                  _c("BIcon", { attrs: { icon: "ballot-outline" } }),
                  _c("span", [_vm._v("Recibo de salario")])
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "RouterLink",
        {
          staticClass: "navbar-item is-flex link-sidebar-products",
          attrs: { to: { name: "SkuCatalog" } }
        },
        [
          _c("BIcon", { attrs: { icon: "barcode" } }),
          _c("span", [_vm._v("Productos")])
        ],
        1
      ),
      _c(
        "RouterLink",
        {
          staticClass: "navbar-item is-flex link-sidebar-customers",
          attrs: { to: { name: "Customers" } }
        },
        [
          _c("BIcon", { attrs: { icon: "account-group" } }),
          _c("span", [_vm._v("Clientes")])
        ],
        1
      ),
      _c(
        "RouterLink",
        {
          staticClass: "navbar-item is-flex link-sidebar-employees",
          attrs: { to: { name: "Employees" } }
        },
        [
          _c("BIcon", { attrs: { icon: "briefcase-outline" } }),
          _c("span", [_vm._v("Empleados")])
        ],
        1
      ),
      _vm.haveMultiUser
        ? _c(
            "RouterLink",
            {
              staticClass: "navbar-item is-flex link-sidebar-secondary-users",
              attrs: { to: { name: "SecondaryUsers" } }
            },
            [
              _c("BIcon", { attrs: { icon: "account-supervisor" } }),
              _c("span", [_vm._v("Usuarios")])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }